/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  style.ts
 */

import { css } from '@emotion/react'

export const COLLAPSED_HEIGHT = 86

export const root = (short?: boolean) => css`
  :root {
    --header-height: ${short ? 72 : COLLAPSED_HEIGHT};
  }
`
